import RelatedTestsSection from "@/components/reports/RelatedTestsSection";
import { getOrderUrl, getTestResultsUrl } from "@/core/urls";

import { REPORT_RELATED_TESTS_QUERY } from "../graphql/queries";

export default function CustomerRelatedTestsSection({ report }) {
  return (
    <RelatedTestsSection
      query={REPORT_RELATED_TESTS_QUERY}
      variables={{
        report: report?.slug,
        allTests: true,
        excludeRetests: true
      }}
      skip={!report?.slug}
      getOrderUrl={getOrderUrl}
      getTestResultUrl={getTestResultsUrl}
    />
  );
}
